import { Component, OnInit, Input } from "@angular/core";
import { NotificationType } from "../notifications.enum";

@Component({
	selector: "notification-icon",
	templateUrl: "./notification-icon.component.html",
	styleUrls: ["./notification-icon.component.scss"]
})
export class NotificationIconComponent implements OnInit {
	@Input() notificationType: NotificationType;

	constructor() {}

	ngOnInit() {}
}
